<script>
import ItemComponent from './Item/component.vue';
import ServiceAdd from './ServiceAdd/component.vue';

export default {
  components: {
    ItemComponent,
    ServiceAdd,
  },
  props: {
    module: {
      type: Object,
    },
  },
  mounted() {
  },
  methods: {
    add(value) {
      this.open(this.module.handlerAdd(value));
    },
    remove(item) {
      this.module.remove(item);
    },
    edit(item) {
      this.open(item, true);
    },
    open(item, edit) {
      item.tariffs = this.module.tariffs.data;
      if (!item.servicePrices) {
        item.servicePrices = [];
      }

      for (const tariff of item.tariffs) {
        let filter = item.servicePrices.filter(i => i.TourTariffId === tariff.TariffId);
        if (!filter.length) {
          item.servicePrices.push({
            Id: 0,
            TourTariffId: tariff.TariffId,
            HasVariants: false,
            IncludeInCost: true,
            IsCommissionService: true,
            IsGroupService: false,
            Netto: 0,
            AgentPrice: 0,
            ClientPrice: 0,
            HotelServicePrices: [],
            tariff: tariff,
          });
        } else {
          filter[0].tariff = tariff;
        }
      }
      const { data } = item;
      this.$fDialog(item, {
        title: `${item.service.value?.label || ''}`,
      })
        .catch(() => {
          if (edit) {
            item.data = data;
          } else {
            this.remove(item);
          }
        });
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      Услуги
      <ServiceAdd
        slot="btn"
        :module="module.serviceAdd"
        @add="add"
      />
    </CardTitle>
    <ItemComponent
      v-for="(item, idx) in module.items"
      :key="idx"
      :module="item"
      @remove="remove(item)"
      @edit="edit(item)"
    />
    <CardNoLength v-if="!module.items.length">
      Добавьте услуги
    </CardNoLength>
  </Card>
</template>
<style lang="scss">

</style>
